// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-shell {
  gap: var(--ui-space-6);
}

.app-header {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: var(--ui-space-4);
  align-items: center;
  padding: var(--ui-space-5) var(--ui-space-6);
  border-radius: var(--ui-radius-xl);
  background: linear-gradient(140deg, rgba(255, 255, 255, 0.96), rgba(248, 252, 255, 0.92));
  border: 1px solid var(--ui-border);
  box-shadow: var(--ui-elevation-2);
}

.header-actions {
  justify-content: flex-end;
}

.view-tabs-shell {
  position: relative;
  margin-bottom: var(--ui-space-4);
}

.view-tabs-shell::before,
.view-tabs-shell::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1.75rem;
  pointer-events: none;
  opacity: 0;
  transition: opacity var(--motion-base) var(--easing-standard);
  z-index: 2;
}

.view-tabs-shell::before {
  left: 0;
  background: linear-gradient(90deg, rgba(237, 243, 246, 0.9), transparent);
}

.view-tabs-shell::after {
  right: 0;
  background: linear-gradient(270deg, rgba(237, 243, 246, 0.9), transparent);
}

.view-tabs-shell[data-overflow-left='true']::before,
.view-tabs-shell[data-overflow-right='true']::after {
  opacity: 1;
}

.view-tabs {
  display: flex;
  gap: 0.5rem;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x proximity;
  scrollbar-width: none;
  padding: 0.32rem;
  border-radius: var(--ui-radius-pill);
  border: 1px solid var(--ui-border);
  background: rgba(255, 255, 255, 0.75);
}

.view-tabs::-webkit-scrollbar {
  display: none;
}

.view-tabs .pill {
  flex: 0 0 auto;
  scroll-snap-align: center;
  min-height: 2.2rem;
}

.filters {
  gap: var(--ui-space-4);
}

@media (max-width: 960px) {
  .app-shell {
    width: min(100% - 1rem, 980px);
    gap: var(--ui-space-5);
  }

  .app-header {
    grid-template-columns: 1fr;
    align-items: flex-start;
    padding: var(--ui-space-4);
    gap: var(--ui-space-3);
  }

  .header-actions {
    width: 100%;
    justify-content: flex-start;
  }

  .filters {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 640px) {
  .app-shell {
    width: calc(100% - 0.5rem);
  }

  .app-header h1 {
    font-size: 1.95rem;
  }

  .view-tabs {
    margin-inline: -0.1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,sBAAsB;EACtB,mBAAmB;EACnB,4CAA4C;EAC5C,kCAAkC;EAClC,yFAAyF;EACzF,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,cAAc;EACd,oBAAoB;EACpB,UAAU;EACV,6DAA6D;EAC7D,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,yEAAyE;AAC3E;;AAEA;EACE,QAAQ;EACR,0EAA0E;AAC5E;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;EAChB,oCAAoC;EACpC,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".app-shell {\n  gap: var(--ui-space-6);\n}\n\n.app-header {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: var(--ui-space-4);\n  align-items: center;\n  padding: var(--ui-space-5) var(--ui-space-6);\n  border-radius: var(--ui-radius-xl);\n  background: linear-gradient(140deg, rgba(255, 255, 255, 0.96), rgba(248, 252, 255, 0.92));\n  border: 1px solid var(--ui-border);\n  box-shadow: var(--ui-elevation-2);\n}\n\n.header-actions {\n  justify-content: flex-end;\n}\n\n.view-tabs-shell {\n  position: relative;\n  margin-bottom: var(--ui-space-4);\n}\n\n.view-tabs-shell::before,\n.view-tabs-shell::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 1.75rem;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity var(--motion-base) var(--easing-standard);\n  z-index: 2;\n}\n\n.view-tabs-shell::before {\n  left: 0;\n  background: linear-gradient(90deg, rgba(237, 243, 246, 0.9), transparent);\n}\n\n.view-tabs-shell::after {\n  right: 0;\n  background: linear-gradient(270deg, rgba(237, 243, 246, 0.9), transparent);\n}\n\n.view-tabs-shell[data-overflow-left='true']::before,\n.view-tabs-shell[data-overflow-right='true']::after {\n  opacity: 1;\n}\n\n.view-tabs {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scroll-snap-type: x proximity;\n  scrollbar-width: none;\n  padding: 0.32rem;\n  border-radius: var(--ui-radius-pill);\n  border: 1px solid var(--ui-border);\n  background: rgba(255, 255, 255, 0.75);\n}\n\n.view-tabs::-webkit-scrollbar {\n  display: none;\n}\n\n.view-tabs .pill {\n  flex: 0 0 auto;\n  scroll-snap-align: center;\n  min-height: 2.2rem;\n}\n\n.filters {\n  gap: var(--ui-space-4);\n}\n\n@media (max-width: 960px) {\n  .app-shell {\n    width: min(100% - 1rem, 980px);\n    gap: var(--ui-space-5);\n  }\n\n  .app-header {\n    grid-template-columns: 1fr;\n    align-items: flex-start;\n    padding: var(--ui-space-4);\n    gap: var(--ui-space-3);\n  }\n\n  .header-actions {\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .filters {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n@media (max-width: 640px) {\n  .app-shell {\n    width: calc(100% - 0.5rem);\n  }\n\n  .app-header h1 {\n    font-size: 1.95rem;\n  }\n\n  .view-tabs {\n    margin-inline: -0.1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
